import ArticleCategoryDetails from './ArticleCategoryDetails';

export default ArticleCategoryDetails;
